<template>
    <app-layout title="Credit Card">
        <page-header>
            <template #title>Credit Card - {{ customer.name }}</template>
            
            <template #actions>
                <jet-button v-if="!vault" type="button" class="" :href="route('customers.card_vault.create', customer.id)">
                    Add
                </jet-button>

                <jet-tertiary-button class="leading-none" :href="route('customers.index')">
                    Close
                </jet-tertiary-button>
            </template>
        </page-header>

        <customer-navigation :customer="customer" />

        <div class="px-8">
            <div class="rounded-t overflow-hidden border border-b-0">
                <table class="table w-full">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-left">Card #</th>
                            <th class="text-left">Expiry</th>
                            <th class="text-left">Name</th>
                            <th class="text-left">Address</th>
                            <th class="text-left">City</th>
                            <th class="text-left">Province</th>
                            <th class="text-left">Postal</th>
                            <th class="text-left">Phone</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="vault != null">
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    <span class="brand">
                                        <img :src="vault.brand_image" class="w-10 h-auto" :class="vault.brand_class" />
                                    </span>
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.last_four }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.formatted_expiry }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.first_name + ' ' + vault.last_name }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.street_number + ' ' + vault.street_name }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.city }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.province }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.postal }}
                                </Link>
                            </td>
                            <td>
                                <Link class="block py-1 h-full" :href="route('customers.card_vault.edit', vault.id)">
                                    {{ vault.phone }}
                                </Link>
                            </td>
                            <td class="text-right">
                                <jet-danger-button class="mx-4" @click="removeCustomerVault(vault)">
                                    Remove
                                </jet-danger-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- <pagination class="inline-flex" :links="orders.links" /> -->

            <jet-confirmation-modal :show="showRemoveModal" @close="closeRemoveModal" v-if="selectedVault">
                <template #title>
                    Remove Credit Card
                </template>

                <template #content>
                    <p>Are you sure you would like to remove credit card <span class="font-bold">{{ selectedVault.last_four }}</span>?</p>
                </template>

                <template #footer>
                    <jet-danger-button @click="handleRemoveVault" :disabled="form.processing">
                        Yes
                    </jet-danger-button>

                    <jet-tertiary-button class="ml-2" @click="closeRemoveModal">
                        No
                    </jet-tertiary-button>
                </template>
            </jet-confirmation-modal>
        </div>
    </app-layout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import CustomerNavigation from '@/Shared/CustomerNavigation';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import Pagination from '@/Jetstream/Pagination';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';

export default {
    components: {
        AppLayout,
        PageHeader,
        CustomerNavigation,
        JetButton,
        JetTertiaryButton,
        Pagination,
        JetConfirmationModal,
        JetDangerButton,
        Link,
    },

    props: ['customer', 'vault'],

    data() {
        return {
            showRemoveModal: false,

            selectedVault: null,
            form: this.$inertia.form(),
        }
    },

    methods: {
        handleRemoveVault () {
            this.form.post(this.route('customers.card_vault.delete', {
                customer_vault: this.selectedVault.id,
            }), {
                onSuccess: () => {
                    this.form.reset();
                    this.showRemoveModal = false;
                }
            });
        },

        removeCustomerVault (vault) {
            this.selectedVault = vault;
            this.showRemoveModal = true;
        },

        closeRemoveModal() {
            this.selectedVault = null;
            this.showRemoveModal = false;
        },
    }
}

</script>

<style scoped>
    .bg-logo {
        background: #efefef;
    }

    .brand {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .brand img {
        max-height: 38px;
    }

    .brand a {
        line-height: 1;
        font-size: 14px;
    }
</style>
